import { api, apiUrl } from "../../../shared/services/service";
import type {
  VesselEvaluationDashboard,
  VesselEvaluationDashboardRequest,
} from "../models/vessel-evaluation.models";
import axios from "axios";

export const getVesselEvaluationDashboard = async (
  request: VesselEvaluationDashboardRequest,
  signal?: AbortSignal,
): Promise<VesselEvaluationDashboard> => {
  const response = await api.get<VesselEvaluationDashboard>(
    `${apiUrl}/pbi/vessel-evaluation/dashboard`,
    {
      params: toRequestParams(request),
      signal,
    },
  );

  return response.data;
};

const toRequestParams = (request: VesselEvaluationDashboardRequest): URLSearchParams => {
  const params = new URLSearchParams();

  Object.entries(request.filters).forEach(([key, values]) => {
    values.forEach((value) => params.append(key, value));
  });
  params.set("sortBy", request.sort.key);
  params.set("sortDirection", request.sort.direction === "ascending" ? "asc" : "desc");
  params.set("offset", String(request.offset));
  params.set("limit", String(request.limit));

  return params;
};

export const getVesselEvaluationErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    const response = error.response?.data as { error?: string; message?: string } | undefined;

    return response?.error ?? response?.message ?? error.message;
  }

  return error instanceof Error ? error.message : "Vessel Evaluation data could not be loaded.";
};
